import React from 'react';

function Hero() {
  return (
    <section className="bg-white py-8 md:py-12">
      <div className="container mx-auto px-4 text-center">
        {/* Logo */}
        <div className="mb-6 md:mb-8">
          <img
            src="/logo-primary.jpg"
            alt="Anders Ponds & Lakes - Tampa Bay Pond and Lake Management Services"
            className="w-48 md:w-56 lg:w-72 mx-auto rounded-lg shadow-lg"
            width="288"
            height="288"
            fetchPriority="high"
          />
        </div>

        {/* H1 for SEO - visually hidden */}
        <h1 className="sr-only">Anders Ponds & Lakes - Tampa Bay Pond and Lake Management</h1>

        {/* Tagline */}
        <p className="text-lg md:text-xl lg:text-2xl text-brand-700 mb-8 md:mb-10 max-w-3xl mx-auto px-4">
          Preservation and Management of Freshwater Ecosystems.
        </p>

        {/* CTAs - Prominent and Mobile-Friendly */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center max-w-xl mx-auto px-4">
          {/* Primary CTA - Call */}
          <a
            href="tel:+17272773366"
            className="w-full sm:w-auto bg-water-600 hover:bg-water-700 text-white font-bold py-4 px-8 rounded-lg transition-colors duration-200 text-lg shadow-lg hover:shadow-xl min-h-[56px] flex items-center justify-center"
          >
            <span className="mr-2">📞</span>
            Call Joe: (727) 277-3366
          </a>

          {/* Secondary CTA - Email */}
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="w-full sm:w-auto bg-nature-600 hover:bg-nature-700 text-white font-bold py-4 px-8 rounded-lg transition-colors duration-200 text-lg shadow-lg hover:shadow-xl min-h-[56px] flex items-center justify-center"
          >
            <span className="mr-2">✉️</span>
            Email for Quote
          </a>
        </div>

        {/* Subtext */}
        <p className="mt-6 text-sm md:text-base text-brand-600">
          Licensed & Insured • Serving Greater Tampa Bay and St. Pete
        </p>
      </div>
    </section>
  );
}

export default Hero;
